// extracted by mini-css-extract-plugin
module.exports = {"errorLayout":"Error_errorLayout__19KlM","status":"Error_status__FFkuu","message":"Error_message__G_Za-"};